import { trackAuditPage } from '@/api/audit'
import { useCache } from '@/hooks/web/useCache'

const { wsCache } = useCache()
let lastTrackKey = ''
let lastTrackAt = 0

const redactAuditPath = (value = '') => {
  return value
    .replace(/(\/premiss\/UserDatas\/[^/]+\/)[^/?#]+/g, '$1***')
    .replace(/fyv1_[A-Za-z0-9]+/g, 'fyv1_***')
}

export const trackPageView = (to: any, from?: any) => {
  const token = wsCache.get('access_token')
  if (!token || to?.path === '/login') return

  const key = `${to.fullPath || to.path}|${from?.fullPath || ''}`
  const now = Date.now()
  if (key === lastTrackKey && now - lastTrackAt < 3000) return
  lastTrackKey = key
  lastTrackAt = now

  trackAuditPage({
    path: redactAuditPath(to.path || ''),
    fullPath: redactAuditPath(to.fullPath || ''),
    fromPath: redactAuditPath(from?.fullPath || ''),
    title: String(to?.meta?.title || '')
  }).catch(() => {})
}
